<template>
  <div class="w-100">
    <div>
      <vue-tags-input
        v-model="selectedPresenterQuery"
        :placeholder="$t('network.networkForm.addPresenters')"
        :add-only-from-autocomplete="presenterSearchResults.length > 0"
        :autocomplete-filter-duplicates="false"
        :autocomplete-items="presenterSearchResults"
        :required="isEmpty"
        :tags="meetingPresenters"
        class="w-100"
        @tags-changed="newPresenterAddedToMeeting"
      >
        <div slot="autocomplete-item" slot-scope="props" @click="props.performAdd(props.item)">
          <ul class="list-group">
            <li style="margin: 5px;">
              <span>{{ props.item.text }}</span><br />
              <small><i class="fa fa-envelope small"></i> {{ props.item.email }}</small>
            </li>
          </ul>
        </div>
      </vue-tags-input>
    </div>
  </div>
</template>
<script>
import debounce from 'lodash/debounce';
import VueTagsInput from '@johmun/vue-tags-input';

export default {
  components: {
    VueTagsInput,
  },
  props: {
    existingPresenters: {
      type: [Array, String],
      default: null,
    },
  },
  data() {
    return {
      selectedPresenterQuery: '',
      meetingPresenters: [],
      presenterSearchResults: [],
      nonExistingPresenters: [],
      isEmpty: true,
    };
  },
  computed: {
    alreadyExistingPresenters() {
      return this.meetingPresenters.filter(p => p.presenter_id || p.user_id);
    },
  },
  watch: {
    selectedPresenterQuery: debounce(function (query) {
      if (query.length > 0)
        this.$http.get('presenters/users?limit=20&query=' + query).then(resp => {
          this.presenterSearchResults = resp.data.map(p => this.getPresenterObjectFromUserModel(p));
        });
    }, 600),
    existingPresenters: {
      handler: function (newVal) {
        if (newVal && newVal.length > 0) {
          // Transform presenter to make it usable by tag-input-field and push to meetingPresenters
          let temp = [];
          if (Array.isArray(newVal)) {
            newVal.forEach(p => temp.push(this.getPresenterObjectFromPresenterModel(p)));
          } else {
            temp.push(this.getPresenterObjectFromPresenterModel(newVal));
          }
          this.newPresenterAddedToMeeting(temp);
        }
      },
      immediate: true,
    },
  },
  methods: {
    newPresenterAddedToMeeting(updatedPresentersList) {
      // update all presenter lists
      if(updatedPresentersList.length > 0){
        this.isEmpty = false;
      } else {
        this.isEmpty = true;
      }
      this.meetingPresenters.splice(0);
      this.nonExistingPresenters.splice(0);
      updatedPresentersList.forEach(p => {
        if (!(p.presenter_id || p.user_id)) this.nonExistingPresenters.push(p);
        this.meetingPresenters.push(p);
      });
      this.$emit(
        'presenter-form-field-update',
        updatedPresentersList.map(a => ({ presenter_id: a.id, user_id: a.user_id, name: a.text }))
      );
    },
    updatePresenterList(updatedData, id, name) {
      let temp = Array.from(this.meetingPresenters);
      let updatedPresenterIndex = temp.findIndex(p => p.presenter_id == id || p.text == name);
      temp.splice(updatedPresenterIndex, 1, updatedData);
      this.newPresenterAddedToMeeting(temp);
    },
    // Object Transformers
    getPresenterObjectFromPresenterModel(p) {
      if (!p.id) return { text: p.name };
      return {
        presenter_id: p.id,
        user_id: p.user.user_id,
        text: p.user.first_name + ' ' + p.user.last_name,
        email: p.user.email,
        short_bio: p.short_bio,
        appointment: p.primary_appointment || null,
        is_registered: p.user.is_registered,
        userModel: p.user,
        presenterModel: p,
      };
    },
    getPresenterObjectFromUserModel(user) {
      return {
        user_id: user.user_id,
        text: user.first_name + ' ' + user.last_name,
        is_registered: user.is_registered,
        email: user.email,
        presenter_id: user.presenter ? user.presenter.id : undefined,
        short_bio: user.presenter ? user.presenter.short_bio : undefined,
        appointment: user.presenter ? user.presenter.primary_appointment || null : undefined,
        userModel: user,
        presenterModel: user.presenter,
      };
    },
  },
};
</script>